export type AppShellState = "loading" | "error" | "content";

// Note: decides the top-level app shell. Only an auth error surfaces the
// blocking ErrorScreen; a live (SignalR) connection problem must NOT, so
// connection-error state is deliberately absent from the inputs here. Connection
// trouble keeps the page and is shown via a non-blocking banner instead (see
// resolveConnectionIssueKind). The initial SignalR connect still counts as
// loading, but only once the user is authenticated.
export function resolveAppShellState(opts: {
  isAuthLoading: boolean;
  isAuthenticated: boolean;
  isConnectionLoading: boolean;
  hasAuthError: boolean;
}): AppShellState {
  if (opts.isAuthLoading || (opts.isAuthenticated && opts.isConnectionLoading)) return "loading";
  if (opts.hasAuthError) return "error";
  return "content";
}
